export type Kit = { id: string; name: string; description: string; repositoryUrl: string | null; guideUrl: string | null };
// Add verified, public resource URLs here when the kit documentation is ready.
// No customer order information or Amazon login is required to use the hub.
export const jumpingKit: Kit = {
  id: 'jumping-kit', name: 'Jumping Kit',
  description: 'Build a controller that spots an obstacle and presses Space. Then put it to the test.',
  repositoryUrl: null,
  guideUrl: null,
};
export const trackerBot: Kit = { id: 'tracker-bot', name: 'Tracker Bot', description: 'Follow the line. Explore the code.', repositoryUrl: null, guideUrl: null };
export const gameConsole: Kit = { id: 'game-console', name: 'Game Console Kit', description: 'Build your console. Make it your game.', repositoryUrl: null, guideUrl: null };
export const officePlant: Kit = { id: 'office-plant', name: 'Office Plant Kit', description: 'A little insight into your plant’s everyday life.', repositoryUrl: null, guideUrl: null };
export const kits: Kit[] = [jumpingKit, trackerBot, gameConsole, officePlant];
